import { createServerFn } from "@tanstack/react-start";

import type { PricingPageContent } from "@/content/pricingPage";
import { contentSource } from "@/content/source";

/**
 * The pricing page's content, at prerender. No committed copy stands behind
 * it: a page with no document is not found, and the prerender stops the build
 * rather than ship a pricing page without its prices.
 */
export const pricingPageCms = createServerFn({ method: "GET" }).handler(
  async (): Promise<PricingPageContent | null> =>
    (await contentSource()).loadPricingPage()
);
